<template>
  <div class="flex space-x-5 flex-1">
    <aside class="space-y-3 p-1 w-70 overflow-auto">
      <router-link
        v-for="(page, i) in pages"
        :key="i"
        class="cursor-pointer flex space-x-2 bg-gray-100 rounded-2xl text-black outline-solid-2 py-3 px-4 page-item item group items-center"
        :to="{ name: 'articles-page-item', params: { id: page.id } }"
      >
        <div class="flex-1">
          <p
            class="font-medium m-0 text-base"
            :class="{ 'opacity-30': !page.title }"
          >
            {{ page.title || 'Без названия' }}
          </p>
        </div>

        <Icon
          v-if="page.isMainPage"
          icon="material-symbols:stars-rounded"
          width="16"
          class="text-purple-500"
        />
      </router-link>

      <div
        class="cursor-pointer flex bg-gray-100 rounded-2xl py-2 px-6 group justify-center"
        @click="addPage"
      >
        <Icon
          icon="ph:plus"
          width="24"
          class="opacity-20 transition-opacity group-hover:opacity-100"
        />
      </div>
    </aside>

    <div v-if="pages.length" class="flex-1 overflow-auto">
      <router-view :key="pageId" />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import List from '../components/List.vue'
import { usePages } from '../composables/pages'

export default {
  components: {
    List
  },
  setup () {
    const router = useRouter()
    const route = useRoute()
    const pageId = computed(() => route.params.id)
    const { pages, addPage } = usePages({ router, route })

    return {
      pageId,
      pages,
      addPage
    }
  }
}
</script>

<style lang="postcss" scoped>
.page-item.router-link-active {
  @apply outline-solid-purple-500;
}
</style>
